import { BrowserRouter } from 'react-router-dom'
import { SideBar } from './Components/Sidebar/Index'
import _Routes from './routes'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SideBar />
        <_Routes />
      </BrowserRouter>
    </div>
  )
}

export default App
